import { render, staticRenderFns } from "./GetDetails.vue?vue&type=template&id=5e3dfd42&scoped=true&"
import script from "./GetDetails.vue?vue&type=script&lang=ts&"
export * from "./GetDetails.vue?vue&type=script&lang=ts&"
import style0 from "./GetDetails.vue?vue&type=style&index=0&id=5e3dfd42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3dfd42",
  null
  
)

export default component.exports